// staffSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notify, notifyAPIMessages } from "../../../helpers/commonFunctions";
import { BASE_URL } from "../../../config";
import axios from "axios";
import { authHeaders } from "../../../helpers/axios";
import { apiEndPoints } from "../../../helpers/constants";

// Add Staff
export const reqToAddStaff = createAsyncThunk(
  "reqToAddStaff",
  async ({ data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.post(
        BASE_URL + apiEndPoints.addStaff,
        data,
        authHeaders()
      );
      onSuccess(response?.data);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

// Get Staff List
export const reqToGetStaffList = createAsyncThunk(
  "reqToGetStaffList",
  async ({ data, onSuccess, onFailure }, thunkAPI) => {

    try {
      const response = await axios.get(
        `${BASE_URL}${apiEndPoints.getStaffs}?tab=${data?.tab || ""}&search=${
          data?.search || ""
        }&page=${data?.page || 1}&limit=${data?.limit || 10}`,
        authHeaders()
      );
      onSuccess(response?.data);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

// Get Staff Details
export const reqToGetStaffDetails = createAsyncThunk(
  "reqToGetStaffDetails",
  async ({ id, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BASE_URL + apiEndPoints.getStaffDetails}/${id}`,
        authHeaders()
      );
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

// Update Staff
export const reqToUpdateStaff = createAsyncThunk(
  "reqToUpdateStaff",
  async ({ id, data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BASE_URL}${apiEndPoints.updateStaff}/${id}`,
        data,
        authHeaders()
      );      
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

// Delete Staff
export const reqToDeleteStaff = createAsyncThunk(
  "reqToDeleteStaff",
  async ({ id, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}${apiEndPoints.deleteStaff}/${id}`,
        authHeaders()
      );      
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

const staffSlice = createSlice({
  name: "staff",
  initialState: {
    loader: false,
    error: null,
    staffList: [],
    staffDetails: {},
    totalCount: 0,
  },
  reducers: {
    // Add any specific reducers if needed
  },
  extraReducers: (builder) => {
    // ADD STAFF
    builder.addCase(reqToAddStaff.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToAddStaff.fulfilled, (state, action) => {
      state.loader = false;
    });
    builder.addCase(reqToAddStaff.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload?.message || "Something went wrong");
    });

    // GET STAFF LIST
    builder.addCase(reqToGetStaffList.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToGetStaffList.fulfilled, (state, action) => {
      state.loader = false;
      state.staffList = action.payload?.data?.result || [];
      state.totalCount = action.payload.headers["x-total-count"];
    });
    builder.addCase(reqToGetStaffList.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload?.message || "Something went wrong");
    });

    // GET STAFF DETAILS
    builder.addCase(reqToGetStaffDetails.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToGetStaffDetails.fulfilled, (state, action) => {
      state.loader = false;
      state.staffDetails = action.payload?.data?.result || {};
    });
    builder.addCase(reqToGetStaffDetails.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload?.message || "Something went wrong");
    });

    // UPDATE STAFF
    builder.addCase(reqToUpdateStaff.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToUpdateStaff.fulfilled, (state, action) => {
      state.loader = false;
    });
    builder.addCase(reqToUpdateStaff.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });

    // DELETE STAFF
    builder.addCase(reqToDeleteStaff.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToDeleteStaff.fulfilled, (state, action) => {
      state.loader = false;
    });
    builder.addCase(reqToDeleteStaff.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });
  },
});

export const { } = staffSlice.actions;
export default staffSlice.reducer;